export default "__VITE_ASSET__bd3a7fac__"